<template>
<div>
  <v-card class="navigation-mob-contanier">
    <v-app-bar
      color="teal"
      dark
      class="app-bar-custom
      navigation-mob"
    >
      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer
      class="navigation-mob"
      v-model="drawer"
      fixed
      temporary
    >
      <v-list nav dense>
        <v-list-item link to="/Dashboard">
          <v-list-item-icon>
            <v-icon>mdi-apps</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{lang == 'en' ? 'Dashboard' : 'Početna strana'}}</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/ManageOwner">
          <v-list-item-icon>
            <v-icon>mdi-account-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{lang == 'en' ? 'Add Owner' : 'Dodaj Vlasnika'}}</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/MyInfo">
          <v-list-item-icon>
            <v-icon>mdi-briefcase-account</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{lang == 'en' ? 'My info' : 'Moji podaci'}}</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/Statistics">
          <v-list-item-icon>
            <v-icon>mdi-chart-bar</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{lang == 'en' ? 'Statistics' : 'Statistika'}}</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/Settings">
          <v-list-item-icon>
            <v-icon>mdi-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{lang == 'en' ? 'Settings' : 'Postavke'}}</v-list-item-title>
        </v-list-item>
        <v-list-item link @click="logout">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{lang == 'en' ? 'Logout' : 'Odjava'}}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-card>
  <v-card class="navigation">
    <v-navigation-drawer permanent expand-on-hover class="teal darken-3 navigation-desc">
      <v-list>
        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title class="title">{{myInfo.companyName}}</v-list-item-title>
            <v-list-item-subtitle class="caption">{{myInfo.email}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list nav dense>
        <v-list-item link to="/Dashboard">
          <v-list-item-icon>
            <v-icon>mdi-apps</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{lang == 'en' ? 'Dashboard' : 'Početna strana'}}</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/ManageOwner">
          <v-list-item-icon>
            <v-icon>mdi-account-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{lang == 'en' ? 'Add Owner' : 'Dodaj Vlasnika'}}</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/MyInfo">
          <v-list-item-icon>
            <v-icon>mdi-briefcase-account</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{lang == 'en' ? 'My info' : 'Moji podaci'}}</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/Statistics">
          <v-list-item-icon>
            <v-icon>mdi-chart-bar</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{lang == 'en' ? 'Statistics' : 'Statistika'}}</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/Settings">
          <v-list-item-icon>
            <v-icon>mdi-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{lang == 'en' ? 'Settings' : 'Postavke'}}</v-list-item-title>
        </v-list-item>
        <v-list-item link @click="logout">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{lang == 'en' ? 'Logout' : 'Odjava'}}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Navigation",
  data: () => ({
    drawer: false,
    group: null,
  }),
  methods: {
    logout() {
      this.$store.dispatch('logout', false)
      this.$router.push('/')
    }
  },
  computed: {
    ...mapState(["lang", "myInfo"]),
  }
};
</script>

<style lang="scss">
  .app-bar-custom {
    width: 100%;
  }
  .navigation-mob-contanier {
    display: none!important;
  }
  .navigation {
    position: fixed!important;
    height: 100vh;
    border-radius: 0!important;
    z-index: 50;
    left: 0;
    * {
      color: $inputColor;
    }
    .theme--light.v-icon {
      color: #cfcfcf;
    }
  }
  
@media (max-width: 768px) {
  .navigation {
    display: none!important;
  }
  .navigation-mob-contanier {
    display: block!important;
  }
}
</style>